import React from "react"
import CreateAssets from "./CreateAssets"
import CreateAssetsMobile from "./CreateAssetsMobile"

const PageAssets = () => {
    return (
        <>
            <CreateAssets />
            <CreateAssetsMobile />
        </>
    )
}
export default PageAssets